// Tiny 3x5 lettering and integer rectangles keep the art crisp at every resolution.
const FONT = {
  A:'010101111101101',B:'110101110101110',C:'011100100100011',D:'110101101101110',E:'111100110100111',F:'111100110100100',
  G:'011100101101011',H:'101101111101101',I:'111010010010111',J:'001001001101010',K:'101101110101101',L:'100100100100111',
  M:'101111111101101',N:'101111111111101',O:'010101101101010',P:'110101110100100',Q:'010101101111011',R:'110101110101101',
  S:'011100010001110',T:'111010010010010',U:'101101101101111',V:'101101101101010',W:'101101111111101',X:'101101010101101',Y:'101101010010010',Z:'111001010100111',
  '0':'111101101101111','1':'010110010010111','2':'110001010100111','3':'110001010001110','4':'101101111001001',
  '5':'111100110001110','6':'011100111101111','7':'111001010010010','8':'111101111101111','9':'111101111001110',
  ':':'000010000010000','!':'010010010000010','.':'000000000000010','+':'000010111010000','-':'000000111000000',
  '/':'001001010100100','%':'101001010100101',"'":'010010000000000','?':'110001010000010',
};
function rect(c, x, y, w, h, color) { c.fillStyle = color; c.fillRect(Math.round(x), Math.round(y), w, h); }
function text(c, value, x, y, color = '#f9edc8', scale = 1, align = 'left') {
  const s = String(value).toUpperCase(), width = (s.length * 4 - 1) * scale;
  if (align === 'center') x -= width / 2;
  if (align === 'right') x -= width;
  for (let i = 0; i < s.length; i++) {
    const glyph = FONT[s[i]]; if (!glyph) continue;
    for (let p = 0; p < 15; p++) if (glyph[p] === '1') rect(c, x + (i * 4 + p % 3) * scale, y + Math.floor(p / 3) * scale, scale, scale, color);
  }
}
function office(c) {
  rect(c, 37, 52, 232, 62, '#4b594d');
  rect(c, 30, 45, 240, 62, '#b2b3a0');
  rect(c, 30, 45, 240, 5, '#e6ddbd');
  rect(c, 30, 67, 240, 4, '#d3cdb3');
  rect(c, 30, 94, 240, 4, '#d3cdb3');
  for (const y of [54, 79]) {
    for (let x = 38; x < 263; x += 19) {
      rect(c, x, y, 15, 12, '#334d59'); rect(c, x + 1, y + 1, 13, 3, '#638383');
      rect(c, x + 9, y + 4, 2, 8, '#9aac9e');
    }
  }
  rect(c, 121, 43, 58, 64, '#ddd6bb'); rect(c, 132, 53, 36, 54, '#889084');
  rect(c, 139, 56, 22, 51, '#314957'); rect(c, 149, 57, 2, 49, '#c7c6ad');
  rect(c, 126, 47, 6, 60, '#eee4c8'); rect(c, 168, 47, 6, 60, '#eee4c8');
  rect(c, 129, 104, 42, 4, '#f0e7cd'); rect(c, 125, 108, 50, 4, '#bdbbab');
  rect(c, 121, 112, 58, 3, '#e2ddc4');
  rect(c, 33, 98, 40, 6, '#d0cbb4'); text(c, 'OFFICE PARK', 36, 99, '#4b554c');
}
function tree(c, x, y) {
  rect(c, x + 5, y + 10, 19, 9, '#315038'); rect(c, x + 11, y + 3, 4, 17, '#806146');
  rect(c, x + 2, y - 7, 23, 18, '#2e583d'); rect(c, x - 1, y - 2, 29, 8, '#386e43');
  rect(c, x + 5, y - 13, 16, 9, '#4e8048'); rect(c, x + 8, y - 15, 8, 6, '#69924f');
  rect(c, x + 3, y - 1, 7, 4, '#759c50'); rect(c, x + 16, y - 7, 5, 5, '#406e40');
}
function car(c, car, time, reduced) {
  const { x, y, color } = car, nudge = !reduced && car.honk > 0 ? Math.sin(time * 60) * 1.5 : 0;
  c.save(); c.translate(Math.round(x + nudge), y);
  rect(c, -8, -12, 20, 31, '#242e30'); rect(c, -11, -12, 3, 7, '#202c30'); rect(c, 8, -12, 3, 7, '#202c30');
  rect(c, -11, 8, 3, 7, '#202c30'); rect(c, 8, 8, 3, 7, '#202c30');
  rect(c, -9, -17, 18, 34, color); rect(c, -7, -15, 14, 3, '#ffffff65');
  rect(c, -7, -9, 14, 7, '#304b5a'); rect(c, -6, -8, 12, 2, '#7ca9ae');
  rect(c, -6, 9, 12, 4, '#304b5a'); rect(c, -8, -17, 4, 2, '#fff2b9'); rect(c, 4, -17, 4, 2, '#fff2b9');
  rect(c, -8, 15, 4, 2, '#e67363'); rect(c, 4, 15, 4, 2, '#e67363');
  if (car.rock) { rect(c, 2, -13, 3, 2, '#e4e4d1'); rect(c, 3, -11, 1, 2, '#39434a'); }
  if (car.dirt) for (let i = 0; i < 7; i++) rect(c, -7 + i * 2, -6 + i % 3 * 4, 4, 3, '#b69866');
  if (car.honk > 0) text(c, 'HONK!', 0, -27, '#ffe5a1', 1, 'center');
  c.restore();
}
function ninja(c, g, reduced, tool) {
  const p = g.player, x = Math.round(p.x), y = Math.round(p.y);
  const bob = !reduced && g.moving ? Math.floor(g.time * 12) % 2 : 0;
  rect(c, x - 8, y + 5, 17, 4, '#24432f66');
  if (g.tool === 2) {
    rect(c, x - 11, y - 6, 22, 17, '#d3ad48'); rect(c, x - 13, y - 4, 4, 6, '#26313a');
    rect(c, x + 9, y - 4, 4, 6, '#26313a'); rect(c, x - 13, y + 6, 4, 6, '#26313a'); rect(c, x + 9, y + 6, 4, 6, '#26313a');
    rect(c, x - 7, y + 4, 14, 7, '#f1ce69'); rect(c, x - 5, y + 1, 10, 3, '#71833d');
  }
  rect(c, x - 5, y - 7 - bob, 10, 12, '#263743'); rect(c, x - 5, y - 15 - bob, 10, 10, '#263743');
  rect(c, x - 4, y - 12 - bob, 8, 4, '#eac59a'); rect(c, x - 2, y - 11 - bob, 1, 1, '#1a2835'); rect(c, x + 2, y - 11 - bob, 1, 1, '#1a2835');
  rect(c, x - 6, y - 15 - bob, 12, 3, tool.color); rect(c, x + 5, y - 15 - bob, 6, 2, tool.color);
  rect(c, x + 9, y - 14 - bob, 3, 4, tool.color); rect(c, x - 5, y - 2, 10, 2, tool.color);
  if (g.tool !== 2) {
    rect(c, x - 5, y + 3, 4, 4 + bob, '#1b2935'); rect(c, x + 1, y + 3, 4, 5 - bob, '#1b2935');
  }
  const tx = Math.round(x + p.dx * 19), ty = Math.round(y + p.dy * (p.dy < 0 ? 25 : 17));
  if (g.tool === 0 || g.tool === 3) {
    c.strokeStyle = '#b5bfac'; c.lineWidth = 2; c.beginPath(); c.moveTo(x + 4, y - 3); c.lineTo(tx, ty); c.stroke();
    rect(c, tx - 3, ty - 2, 6, 4, g.tool === 0 ? '#e27c47' : '#293f4b');
    if (g.tool === 3) { rect(c, x - 8, y - 7, 5, 9, '#a281bc'); }
    if (g.working && !reduced) {
      for (let i = 0; i < 4; i++) {
        const offset = (g.time * 60 + i * 7) % 22;
        rect(c, tx + p.dx * offset + (i % 2 * 3 - 1), ty + p.dy * offset, 2, 2, tool.color);
      }
    }
  } else if (g.tool === 1) {
    c.strokeStyle = '#b9c2ad'; c.lineWidth = 2; c.beginPath(); c.moveTo(x, y); c.lineTo(tx, ty); c.stroke();
    rect(c, tx - 7, ty - 5, 14, 11, '#5bb4bc'); rect(c, tx - 4, ty - 3, 8, 6, '#388080');
    for (const a of [-8, 6]) { rect(c, tx + a, ty - 5, 3, 4, '#26313a'); rect(c, tx + a, ty + 3, 3, 4, '#26313a'); }
  }
}
export function drawLawn(c, g, reduced, tools, lawns) {
  c.save(); c.scale(2, 2); c.imageSmoothingEnabled = false;
  rect(c, 0, 0, 300, 350, '#253c3c');
  rect(c, 0, 0, 300, 39, '#1d3034'); rect(c, 0, 39, 300, 3, '#dacb84');
  text(c, 'LAWN NINJAS', 10, 8, '#eff0b5', 2); text(c, `SHIFT ${g.level}`, 290, 10, '#91c9b1', 1, 'right');
  text(c, String(g.score).padStart(6, '0'), 10, 25, '#f7d782');
  text(c, `${Math.ceil(g.remaining)} SEC`, 290, 24, g.remaining < 15 ? '#ff9472' : '#f4edcc', 1, 'right');
  rect(c, 91, 26, 100, 4, '#41584d'); rect(c, 91, 26, Math.round(100 * (g.progress || 0)), 4, '#b0d65d');
  text(c, `${Math.floor((g.progress || 0) * 100)}% CLEAN`, 141, 33, '#bad1b2', 1, 'center');
  rect(c, 0, 42, 300, 277, '#7f9b54');
  rect(c, 5, 116, 290, 13, '#d1ccae'); rect(c, 132, 115, 36, 118, '#d1ccae');
  rect(c, 7, 214, 286, 17, '#e0d8bb'); rect(c, 7, 214, 286, 2, '#f0e7cd');
  rect(c, 68, 233, 164, 74, '#747b71'); rect(c, 68, 233, 164, 2, '#d1ccae');
  for (let x = 68; x < 234; x += 41) { rect(c, x, 249, 2, 51, '#d8d3a9'); rect(c, x, 298, 41, 2, '#d8d3a9'); }
  rect(c, 5, 307, 290, 11, '#bdbb9e');
  for (const lawn of lawns) {
    rect(c, lawn.x - 2, lawn.y - 2, lawn.w + 4, lawn.h + 4, '#496c3e');
    rect(c, lawn.x, lawn.y, lawn.w, lawn.h, '#83ae4d');
    for (let y = lawn.y; y < lawn.y + lawn.h; y += 12) rect(c, lawn.x, y, lawn.w, 6, '#91b852');
  }
  for (const j of g.jobs) {
    if (j.kind === 'grass') {
      if (!j.done) {
        rect(c, j.x - 3, j.y - 2, 1, 5, '#496f38'); rect(c, j.x - 2, j.y + 1, 4, 2, '#507c39');
        rect(c, j.x + 2, j.y - 4, 1, 6, '#537b39');
      } else rect(c, j.x - 5, j.y + 2, 9, 1, '#bad478');
    } else if (j.kind === 'edge') {
      if (!j.done) for (let i = 0; i < 5; i++) rect(c, j.x - 5 + i * 3, j.y - (i % 2 ? 3 : 5), 2, 7, '#345d37');
    } else if (j.kind === 'bush') {
      rect(c, j.x - 9, j.y - 5, 20, 8, '#315139');
      rect(c, j.x - 9, j.y - (j.done ? 8 : 11), 18, j.done ? 9 : 13, j.done ? '#66954b' : '#416f3b');
      rect(c, j.x - 7, j.y - (j.done ? 8 : 11), 14, 3, j.done ? '#9fbd66' : '#709449');
      if (!j.done) { rect(c, j.x - 12, j.y - 6, 4, 4, '#416f3b'); rect(c, j.x + 6, j.y - 14, 4, 7, '#416f3b'); }
    } else if (!j.done && j.kind === 'leaves') {
      for (let i = 0; i < 9; i++) rect(c, j.x - 7 + (i * 7) % 14, j.y - 3 + (i * 3) % 8, 4, 2, ['#d99843', '#edd275', '#a76d39'][i % 3]);
    } else if (!j.done && j.kind === 'dirt') {
      rect(c, j.x - 5, j.y, 11, 4, '#96734b'); rect(c, j.x - 3, j.y - 2, 7, 3, '#bb9460');
    }
    if (!j.done && j.work > 0) { rect(c, j.x - 6, j.y + 8, 12, 2, '#233d38'); rect(c, j.x - 6, j.y + 8, Math.min(12, j.work * 26), 2, '#ffe49a'); }
  }
  for (const stone of g.stones) if (!stone.used) { rect(c, stone.x - 2, stone.y, 5, 3, '#e1ddc1'); rect(c, stone.x, stone.y - 1, 2, 1, '#fbf0cb'); }
  office(c); tree(c, 3, 87); tree(c, 268, 87);
  for (const a of g.cars) car(c, a, g.time, reduced);
  ninja(c, g, reduced, tools[g.tool]);
  if (!reduced) for (const p of g.particles) rect(c, p.x, p.y, 2, 2, p.color);
  for (const s of g.shots) {
    if (s.kind === 'dirt') { rect(c, s.x - 5, s.y - 3, 9, 6, '#c7a879'); rect(c, s.x - 2, s.y - 5, 5, 10, '#b49465'); }
    else rect(c, s.x - 1, s.y - 1, 3, 3, '#f9edcc');
  }
  for (const p of g.popups) text(c, p.text, Math.max(45, Math.min(250, p.x)), p.y, p.color, 1, 'center');
  rect(c, 0, 319, 300, 31, '#1d3034'); rect(c, 0, 319, 300, 2, '#dacb84');
  const tool = tools[g.tool]; text(c, `${g.tool + 1} ${tool.name}`, 9, 326, tool.color);
  text(c, `CAR BONUS ${g.mischief}`, 290, 326, '#f6db91', 1, 'right');
  const msg = g.messageTime > 0 ? g.message : 'MOW GRASS. TRIM HEDGES. BLOW LEAVES + DIRT.';
  text(c, msg, 150, 339, '#c1d5b1', 1, 'center');
  c.restore();
}
